import IframeWindow from "./IframeWindow";

export default IframeWindow;
